
/* injects from baggage-loader */
var Template = require('./template.js');

import { Component } from 'react';
import { connect } from "react-redux";

class InactiveTerminal extends Component {
    render () {
        // eslint-disable-next-line no-undef
        return Template.default.apply(this);
    }
}

const mapStateToProps = ({ uiState }) => ({
    idlePopupOpen: uiState.idlePopupOpen,
});

export default connect(mapStateToProps)(InactiveTerminal);